import styled from 'styled-components/macro';
import { checkWhite } from '../../assets/icons';

const disabledCheckbox = (disable?: boolean) => {
  return disable
    ? { cursor: 'default', opacity: '0.5' }
    : { cursor: 'pointer' };
};

export const StyledLabel = styled.label<{ disable?: boolean }>`
  ${(props) => disabledCheckbox(props.disable)};
  display: flex;
  gap: 8px;
  align-items: center;

  * {
    box-sizing: border-box;
  }
`;

export const CheckboxContainer = styled.div<{ size: number }>`
  position: relative;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

export const StyledCheckbox = styled.div<{ checked: boolean; size: number }>`
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  background: ${(props) => (props.checked ? '#2d67d8' : '#ffffff')};
  border: 2px solid ${(props) => (props.checked ? 'transparent' : '#9da6b4')};
  border-radius: 8px;
  transition: all 150ms;

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px #e0eeff;
  }
`;

export const CheckIcon = styled.img.attrs({ src: checkWhite })<{
  size: number;
}>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;
